export default __webpack_public_path__ + "static/media/4749.cd21bd65.png";